import { apiFetch } from "./client.js";

export interface PostKidTransferBody {
  toKidId: string;
  amountCents: number;
  note: string;
}

export interface PostKidTransferResponse {
  ok: true;
  rowKey: string;
}

export async function postKidTransfer(body: PostKidTransferBody): Promise<PostKidTransferResponse> {
  return apiFetch<PostKidTransferResponse>(
    "/api/kid-transfers",
    { method: "POST", body: JSON.stringify(body) },
    true,
  );
}
